import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import {Button, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import * as mammoth from "mammoth";
import { useState } from "react";
import { aiRecognize } from "../../../http/AI";


const style = {
    position: 'absolute',
    top: '10%',
    bottom: '20%',
    left: '20%',
    right: '20%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    overflow: 'auto',
    height: '85%',
    p: 4,
};

export default function AIRecognizeProtocol({data, open, setOpen, ...props}) {   
    const [content, setContent] = useState(null);
    const [tables, setTables] = useState([]);

    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        if (file) {
            try {
                // Convert .docx to HTML using mammoth
                const arrayBuffer = await file.arrayBuffer();
                const mammothResult = await mammoth.convertToHtml({ arrayBuffer });
                setContent(mammothResult.value);

                // Convert file to base64 for API
                const reader = new FileReader();
                reader.onload = async () => {
                    const base64Content = reader.result.split(",")[1]; // Получение base64 после префикса DataURL

                    // Отправка на API
                    try {
                        const response = await aiRecognize.post("upload/word", { content: base64Content });
                        if (response && response.tables) {
                            setTables(response.tables);
                        } else {
                            console.error("Ответ API не содержит таблиц");
                        }
                    } catch (error) {
                        console.error("Ошибка при вызове API:", error);
                    }
                    // // Заглушка для API
                    // const mockResponse = {
                    //     tables: [
                    //         {
                    //             Rows: [
                    //                 ["Íàçâàíèå ̉åṇ̃à", "вок ГЕПАТИТ в 02.10.2024"],
                    //                 ["Íà÷àëî ̉åṇ̃à", "02.10.2024 14:34:47"],
                    //                 ["̉åṇ̃ Çàêîí÷åí", "02.10.2024 15:56:54"],
                    //                 ["Îïåđạ̀îđ", "женис"],
                    //                 ["Çà́å÷àíèÿ", "АмплиСенс HBV - FL №20.04.24 до 2025.04.20"],
                    //                 ["̉åṇ̃. âûïîëíåí ïđîãđà́́îé âåđñèè", "Rotor-Gene 1.8.17.5"],
                    //                 ["Ïîäïèñü ̉åṇ̃à", "Ïîäïèñü ̉åṇ̃à ïđàâèëüíà."],
                    //                 ["Óđîâåíü ñèãíàëà Green", "10,"],
                    //                 ["Óđîâåíü ñèãíàëà Yellow", "10,"]
                    //             ]
                    //         },
                    //         {
                    //             Rows: [
                    //                 ["№", "Имя", "CT", "Конц.Стандарта (Копии)", "Конц. Расч. (Копии)", "Коэфф. Вариации %", "Сред. Ct", "Ст.Откл Сред. Ct"],
                    //                 ["1", "HV-P-2024-15-01", "23,60", "", "", "", "23,60", ""],
                    //                 ["2", "HV-P-2024-15-02", "23,77", "", "", "", "23,77", ""],
                    //                 ["3", "HV-P-2024-15-03", "24,44", "", "", "", "24,44", ""],
                    //                 ["4", "HV-P-2024-15-04", "23,99", "", "", "", "23,99", ""],
                    //                 ["5", "HV-P-2024-15-05", "22,31", "", "", "", "22,31", ""],
                    //                 ["6", "око", "22,24", "", "", "", "22,24", ""],
                    //                 ["7", "к-", "", "", "", "", "", ""],
                    //                 ["8", "Вк+", "24,01", "", "", "", "24,01", ""],
                    //                 ["9", "к+HBV", "27,53", "", "", "", "27,53", ""]
                    //             ]
                    //         },
                    //         {
                    //             Rows: [
                    //                 ["", "Ựị̂ ị̂÷¸̣ ñîçäàí Rotor-Gene 6000 Series Software 1.8.17.5\nCopyright 2000-2006 Corbett Research, a Division of Corbett Life Science. Âñå Ïđàâà Çàùèùåíû.\nISO 9001:2000 (Reg. No. QEC21313) "]
                    //             ]
                    //         }
                    //     ]
                    //};
                    //setTables(mockResponse.tables || []);
                };
                reader.readAsDataURL(file);
            } catch (error) {
                console.error("Error reading file or processing mock API:", error);
            }
        }
    };

    console.log(data);
    
    const handleClose = async () => {
        setOpen(false);
    };

    return (
        <div>
            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title"
                   aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <Grid container spacing={2} direction='column'>                        
                        <Grid item><Typography variant='h6' component='h2'>Протокол {data?.number}</Typography></Grid>
                    </Grid>

                    <Grid item>
                            <Button variant="contained" component="label">
                                Распознать Word
                                <input type="file" hidden accept=".docx" onChange={handleFileUpload} />
                            </Button>
                        </Grid>

                        {content && (
                            <Grid item>
                                <Typography variant="body1">Содержимое документа:</Typography>
                                <Box sx={{ border: "1px solid #ccc", padding: "10px", marginTop: "10px", maxHeight: "300px", overflow: "auto" }}>
                                    <div dangerouslySetInnerHTML={{ __html: content }} />
                                </Box>
                            </Grid>
                        )}

                        {tables.length > 0 && (
                            <Grid item>
                                <Typography variant="h6">Таблицы</Typography>
                                {tables.map((table, index) => (
                                    <TableContainer key={index}>
                                        <Table>
                                            <TableBody>
                                                {table.Rows.map((row, idx) => (
                                                    <TableRow key={idx}>
                                                        {row.map((cell, idy) => (
                                                            <TableCell key={idy}>{cell}</TableCell>
                                                        ))}
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                ))}
                            </Grid>
                        )}
                </Box>
            </Modal>
        </div>
    )
}
